var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2239 0.871704C5.97615 0.871704 0.0996094 6.74824 0.0996094 13.996C0.0996094 19.2874 1.94316 20.7653 11.8773 35.1658C12.5288 36.107 13.9218 36.107 14.5732 35.1658C24.5026 20.7632 26.3482 19.2867 26.3482 13.996C26.3482 6.74824 20.4696 0.871704 13.2239 0.871704ZM13.2239 19.4029C10.2074 19.4029 7.75545 16.9503 7.75545 13.9345C7.75545 10.9186 10.2094 8.46602 13.2239 8.46602C16.2384 8.46602 18.6924 10.9186 18.6924 13.9345C18.6924 16.9503 16.2384 19.4029 13.2239 19.4029Z",
    fill: "#0a1d47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.95c50d99f9d721c0c814ca829f1d000d.svg";
export { ForwardRef as ReactComponent };